<script>
    import { onDestroy } from 'svelte';

    export let peer;

    let name = "";
    const unsub = peer.name.subscribe(n => { name = n; });
    onDestroy(unsub);

    const ROLE_LABEL = {
        eng: "ENGINEER",
        talent: "TALENT",
    };

    $: roleLabel = ROLE_LABEL[peer.type];
    $: eyebrow = roleLabel ? `▸ ${roleLabel}` : null;
</script>

<div class="peer-label" class:is-self={peer.is_self} title={name || "Guest"}>
    <div class="peer-label__eyebrow" aria-hidden={!eyebrow}>{eyebrow ?? " "}</div>
    <div class="peer-label__name">{name || "Guest"}</div>
</div>

<style lang="scss">
    @import "../styles/variables.scss";

    .peer-label {
        padding: 12px 16px;
        min-width: 150px;
        max-width: 180px;
        background: rgba(255, 255, 255, 0.02);
        border: 0.5px solid rgba(232, 228, 220, 0.14);
        border-radius: $rounded-md;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .peer-label.is-self {
        background: rgba(190, 157, 134, 0.04);
        border-color: rgba(190, 157, 134, 0.25);
    }

    .peer-label__eyebrow {
        font-family: ui-monospace, "SF Mono", "JetBrains Mono", Menlo, monospace;
        font-size: 9px;
        font-weight: 500;
        letter-spacing: 0.22em;
        color: $accent-color;
        text-transform: uppercase;
    }

    .peer-label__name {
        font-size: 1.3em;
        font-weight: 500;
        line-height: 1.25;
        color: rgba(242, 239, 232, 0.61);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
